import { dateTimeFieldPolicy } from "@fai/custom-codegen-plugins";

export const scalarTypePolicies = {
  BackofficeAlgosearchResult: { fields: { createdAt: dateTimeFieldPolicy, deletedAt: dateTimeFieldPolicy } },
  ClientMemberEdge: { fields: { joinedAt: dateTimeFieldPolicy } },
  ClientSession: { fields: { createdAt: dateTimeFieldPolicy } },
  ClientTeam: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ClientTeamMember: { fields: { joinedAt: dateTimeFieldPolicy } },
  ClientTeamStripePaymentMethod: { fields: { updatedAt: dateTimeFieldPolicy } },
  ClientUser: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ClientUserIntegrationHuggingFace: {
    fields: { createdAt: dateTimeFieldPolicy, lastUsedAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy },
  },
  ClientUserIntegrationWandb: {
    fields: { createdAt: dateTimeFieldPolicy, lastUsedAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy },
  },
  ClientUserPat: { fields: { createdAt: dateTimeFieldPolicy } },
  ClientUserTeam: { fields: { joinedAt: dateTimeFieldPolicy } },
  ClientUserTeamEdge: { fields: { joinedAt: dateTimeFieldPolicy } },
  ContainerImage: { fields: { createdAt: dateTimeFieldPolicy } },
  ContainerRepository: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ContainerSubplan: {
    fields: { expiresAt: dateTimeFieldPolicy, joinedAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy },
  },
  ContainerSubplanSecret: { fields: { expiresAt: dateTimeFieldPolicy, lastUsed: dateTimeFieldPolicy } },
  ContainerSubplanServingInstance: { fields: { createdAt: dateTimeFieldPolicy, lastSyncedAt: dateTimeFieldPolicy } },
  ContainerTag: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedAdapter: { fields: { createdAt: dateTimeFieldPolicy } },
  DedicatedDatasetChat: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedDocument: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedEndpoint: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedEndpointAccessLog: { fields: { timestamp: dateTimeFieldPolicy } },
  DedicatedEndpointContentLog: { fields: { timestamp: dateTimeFieldPolicy } },
  DedicatedEndpointLatencyMetricTimeSeriesObservation: { fields: { timestamp: dateTimeFieldPolicy } },
  DedicatedEndpointLog: { fields: { timestamp: dateTimeFieldPolicy } },
  DedicatedEndpointTrafficByStatusMetricTimeSeriesObservation: { fields: { timestamp: dateTimeFieldPolicy } },
  DedicatedEndpointVersion: {
    fields: { createdAt: dateTimeFieldPolicy, statusUpdatedAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy },
  },
  DedicatedFinetuning: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedFinetuningSubscriptionResponse: {
    fields: { createdAt: dateTimeFieldPolicy, timestamp: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy },
  },
  DedicatedModel: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedProject: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  DedicatedProjectDayCostUsageTimeSeriesObservation: { fields: { timestamp: dateTimeFieldPolicy } },
  IntTimeSeriesObservation: { fields: { timestamp: dateTimeFieldPolicy } },
  IntegrationNotionPage: { fields: { createdAt: dateTimeFieldPolicy, lastEditedAt: dateTimeFieldPolicy } },
  IntegrationNotionWorkspace: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  RegistryRepository: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  RegistryTag: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ServerlessChat: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ServerlessContentDocument: { fields: { createdAt: dateTimeFieldPolicy, syncedAt: dateTimeFieldPolicy } },
  ServerlessContentNotion: { fields: { createdAt: dateTimeFieldPolicy, syncedAt: dateTimeFieldPolicy } },
  ServerlessContentWebsite: { fields: { createdAt: dateTimeFieldPolicy, syncedAt: dateTimeFieldPolicy } },
  ServerlessFile: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ServerlessKnowledge: { fields: { createdAt: dateTimeFieldPolicy, updatedAt: dateTimeFieldPolicy } },
  ServerlessSubplanResponse: { fields: { timestamp: dateTimeFieldPolicy } },
  UnionTimeSeriesObservation: { fields: { timestamp: dateTimeFieldPolicy } },
};
